import { useEffect, useState, useRef } from 'react';

const breakpoint = 768;

const useIsMobile = (): boolean => {
  const requestRef = useRef<number>(0);
  const [width, setWidth] = useState<number>(
    typeof window === 'object' ? window.innerWidth : 0,
  );

  const handleWindowSizeChange = () => setWidth(window.innerWidth);

  useEffect(() => {
    requestRef.current = requestAnimationFrame(handleWindowSizeChange);
    return () => cancelAnimationFrame(requestRef.current);
  }, []);

  return width <= breakpoint;
};

export default useIsMobile;
